import { Text, View } from '@react-pdf/renderer';

import { Contract } from '@/types/ContractType';
import { styles } from '../style';

const Zoning = ({ contract }: { contract: Contract }) => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>ZONING</Text>
      <Text style={styles.text}>
        1. Failure of this Agreement to contain the zoning classification
        (except in cases where the property and each parcel thereof, if
        subdividable, is zoned solely or primarily to permit single-family
        dwellings) will render this Agreement voidable at Buyer’s option, and,
        if voided, any deposits tendered by the Buyer will be returned to the
        Buyer without any requirement for court action.
      </Text>
      <Text style={styles.text}>
        2. Zoning Classification, as set forth in the local zoning ordinance:{' '}
        <Text style={styles.InfoText}>
          {contract?.agentSellerInfo?.zoning ?? ''}
        </Text>
      </Text>
    </View>
  );
};

export default Zoning;
